import type {SidebarIdT} from '@freckle/classroom/ts/common/components/sidebar/common/logic'
import {SidebarSection} from '@freckle/classroom/ts/common/components/sidebar/common/section'
import {SidebarLink} from '@freckle/classroom/ts/common/components/sidebar/common/sidebar-link-button/link'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'
import type {SectionLinkInfoT} from './../section-main'

type Props = {
  showOnlyMath: boolean
}

type SectionInfo = {
  route: string
  tabId: SidebarIdT
}

export function SidebarSectionSubjects(props: Props) {
  const {showOnlyMath} = props

  const mathSubjectSectionLinkInfo: SectionInfo = {
    route: Routes.math.overview(),
    tabId: 'math-tab',
  }
  const otherSubjectSectionLinkInfo: SectionInfo[] = [
    {
      route: Routes.ela.overview(),
      tabId: 'ela-tab',
    },
    {
      route: Routes.socialStudies.units(),
      tabId: 'social-studies-tab',
    },
    {
      route: Routes.science.units(),
      tabId: 'science-tab',
    },
  ]

  return (
    <SidebarSection>
      <>
        <SidebarLink
          key={mathSubjectSectionLinkInfo.tabId}
          tabId={mathSubjectSectionLinkInfo.tabId}
          href={mathSubjectSectionLinkInfo.route}
        />

        {!showOnlyMath ? <SidebarLinks links={otherSubjectSectionLinkInfo} /> : null}
      </>
    </SidebarSection>
  )
}

type SidebarLinksProps = {
  links: Array<SectionLinkInfoT>
}

function SidebarLinks(props: SidebarLinksProps) {
  return (
    <>
      {props.links.map(({tabId, route}) => (
        <SidebarLink key={tabId} tabId={tabId} href={route} />
      ))}
    </>
  )
}
